<template>
    <div class="flex h-full flex-col">
        <div>
            <CompanyBar />
            <Tab :class="{'pointer-events-none cursor-not-allowed': isLimitedChecked}" />
        </div>
        <NoPermission v-if="isLimitedChecked" />

        <router-view class="flex-1 bg-grey-10 p-6" v-else></router-view>
    </div>
</template>

<script setup lang="ts">
import CompanyBar from '@/components/CompanyBar.vue'
import NoPermission from '@/components/NoPermission.vue';
import Tab from '@/components/Tab.vue'
import { useGlobalState } from '@/composables/use-global-store';
const { isLimitedChecked } = useGlobalState()
</script>
